// @flow weak

import {ADMIN} from '../roles';
import {GET} from '../helpers/request';

export const GET_REQUEST = '@orderList/GET_REQUEST';
export const GET_SUCCESS = '@orderList/GET_SUCCESS';
export const GET_FAILURE = '@orderList/GET_FAILURE';
export const FILTER = '@orderList/FILTER';
export const SORT = '@orderList/SORT';

const ordersRequest = () => ({
  type: GET_REQUEST,
});

const ordersSuccess = (orders, salesUsers) => ({
  type: GET_SUCCESS,
  salesUsers,
  orders,
});

const ordersFailure = error => ({
  type: GET_FAILURE,
  error,
});

export const fetchOrders = () => async dispatch => {
  dispatch(ordersRequest());
  try {
    const orders = await GET({endpoint: '/orders'}, dispatch);
    const salesUsers = await GET({endpoint: `/users/?role=${ADMIN}`}, dispatch);
    dispatch(ordersSuccess(orders, salesUsers));
  } catch (err) {
    dispatch(ordersFailure(err));
  }
};

export const filterOrders = ({
  archived = false,
  orderState = null,
  salesUserId = null,
  query = null,
  projectId = null,
} = {}) => ({
  type: FILTER,
  archived,
  orderState,
  salesUserId,
  query,
  projectId,
});

export const sortItems = sorter => ({
  type: SORT,
  sorter,
});



// WEBPACK FOOTER //
// ./src/actions/orderList.js